module.exports = __webpack_public_path__ + "img/warning_red.5764b4db.svg";